import { render, staticRenderFns } from "./JointWarning.vue?vue&type=template&id=21fd2b34"
import script from "./JointWarning.vue?vue&type=script&lang=js"
export * from "./JointWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports